module.exports = new __parcel__URL__("development-preview.bf178645.svg").toString();